import { render, staticRenderFns } from "./Disburstment.vue?vue&type=template&id=fb18389c&scoped=true"
import script from "./Disburstment.vue?vue&type=script&lang=js"
export * from "./Disburstment.vue?vue&type=script&lang=js"
import style0 from "./Disburstment.vue?vue&type=style&index=0&id=fb18389c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb18389c",
  null
  
)

export default component.exports